import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_TextValue = _resolveComponent("TextValue");
  const _component_TargetingFilterBody = _resolveComponent("TargetingFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "targetings",
    ref: "targetingFilterItem",
    icon: "TargetIcon",
    title: $options.getTargetingTitle,
    selectedTitle: $options.getTargetingSelectedTitle,
    selectedCount: $props.targetings?.filterState?.selectedCount,
    onClearAll: $options.onClear,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, _createSlots({
    body: _withCtx(() => [_createVNode(_component_TargetingFilterBody, {
      title: $props.title,
      selected: $props.targetings?.filterState?.selected,
      isModified: $props.targetings.isModified,
      pendingChanges: $props.targetings.pendingChanges,
      isSearching: $props.targetings.isSearching,
      keyword: $props.targetings.keyword,
      list: $props.targetings.displayList,
      onClear: $options.onClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.targetings.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: $options.onApply,
      onSearch: $options.handleSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.targetingFilterItem?.closeDropdown
    }, null, 8, ["title", "selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 2
  }, [$options.getTargeting ? {
    name: "title",
    fn: _withCtx(() => [_createVNode(_component_TextValue, {
      value: $options.truncateString($options.getTargeting.targeting, 16),
      main: "",
      styles: {
        width: 'auto !important'
      }
    }, null, 8, ["value"])]),
    key: "0"
  } : undefined]), 1032, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}